var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Editor',{attrs:{"id":_vm.tinymceId,"init":_vm.tinymceData},model:{value:(_vm.tinymceHtml),callback:function ($$v) {_vm.tinymceHtml=$$v},expression:"tinymceHtml"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }